// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"ojOrWUE6tlNi5sHRmfHz"};